import { createActions, createState, createReducer } from 'reduxsauce-crud'

const DEEP = { deep: true }

export const PaymentRemindersRedux = createActions(
  {
    getAllRequest: ['centerId', 'queries'],
    getAllSuccess: ['results'],
    getAllError: ['error'],
    sendAllRequest: ['centerId'],
    sendAllSuccess: ['results'],
    sendAllError: ['error'],
    sendOneRequest: ['studentId'],
    sendOneSuccess: ['results'],
    sendOneError: ['error'],
  },
  {
    prefix: 'PAYMENT_REMINDERS_',
    defaultActions: {
    },
  },
)

const { Types, Creators } = PaymentRemindersRedux
export const PaymentRemindersTypes = Types
export default Creators

export const INITIAL_STATE = createState({
  get: {
    fetching: false,
    results: [],
    error: null,
  },
  sendReminder: {
    fetching: false,
    success: false,
    error: null,
  },
}, {
})

const getAllRequest = state => state.merge({ get: { fetching: true } }, DEEP)
const getAllSuccess = (state, { results }) =>
  state.merge({ get: { fetching: false, results, error: null } }, DEEP)
const getAllError = (state, { error }) =>
  state.merge({ get: { fetching: false, error } }, DEEP)

const sendRemindersRequest = state => state.merge({ sendReminder: { fetching: true } }, DEEP)
const sendRemindersSuccess = (state, { results }) =>
  state.merge({
    sendReminder: { fetching: false, success: true },
    get: { results: { data: results } },
  }, DEEP)
const sendRemindersError = (state, { error }) =>
  state.merge({ sendReminder: { fetching: false, error } }, DEEP)

export const reducer = createReducer(
  INITIAL_STATE, {
    [Types.getAllRequest]: getAllRequest,
    [Types.getAllSuccess]: getAllSuccess,
    [Types.getAllError]: getAllError,
    [Types.sendAllRequest]: sendRemindersRequest,
    [Types.sendAllSuccess]: sendRemindersSuccess,
    [Types.sendAllError]: sendRemindersError,
    [Types.sendOneRequest]: sendRemindersRequest,
    [Types.sendOneSuccess]: sendRemindersSuccess,
    [Types.sendOneError]: sendRemindersError,
  },
  {
    defaultActions: {
    },
    Types,
  },
)



// WEBPACK FOOTER //
// ./src/Data/Redux/PaymentRemindersRedux.js